<template>
    <div class="d-flex flex-column align-items-center download-banner-v3 col-lg-12 md:col-md-12">
        <span class="text-center font-md headline">
            Download the refreshed Home Credit App
        </span>
        
        <span v-if="description" class="text-center text-secondary font-xs px-4">
            {{ description }}
        </span>

        <span v-else class="text-center text-secondary font-xs px-4">
            You need to install and register in the new Home Credit app to authorize payments. Download now!
        </span>

        <div
            :class="btnWrapperCls" 
            class="mb-4 d-flex flex-row align-items-center justify-content-between mt-3 gap-3">
            <button type="button" :id="googlePlayId"
                :class="buttonClass" 
                class="btn btn-success btn-block align-items-center gap-2 d-flex flex-row"
                @click="googlePlay">
                <label class="align-items-center m-0">
                    <img alt="" src="/img/playstore.svg" class="img-responsive">
                </label>

                <label class="d-flex flex-column align-items-center m-0 p-0">
                    <span class="font-xs text-center dowloadon">{{ EnumLabels.DOWNLOADON }}</span>
                    <span class="font-sm text-center justify dowloadlabel">{{ EnumLabels.PLAYSTORE }}</span>
                </label>
            </button>
            <button type="button"
                :class="buttonClass" 
                class="btn btn-success btn-block align-items-center gap-2 mt-0 d-flex flex-row"
                @click="appleStore">
                <label class="align-items-center m-0">
                    <img alt="" src="/img/appstore.svg" class="img-responsive">
                </label>

                <label class="d-flex flex-column align-items-center m-0 p-0">
                    <span class="font-xs text-center dowloadon">{{ EnumLabels.DOWNLOADON }}</span>
                    <span class="font-sm text-center justify dowloadlabel">{{ EnumLabels.APPSTORE }}</span>
                </label>
            </button>
            
            <button type="button"
                :class="buttonClass" 
                class="btn btn-success btn-block align-items-center gap-2 mt-0 d-flex flex-row"
                @click="huaweiStore">
                <label class="align-items-center m-0">
                    <img alt="" src="/img/huawei_store.svg" class="img-responsive">
                </label>

                <label class="d-flex flex-column align-items-center m-0 p-0">
                    <span class="font-xs text-center dowloadon">{{ EnumLabels.DOWNLOADON }}</span>
                    <span class="font-sm text-center justify dowloadlabel">{{ EnumLabels.APPGALLERY }}</span>
                </label>
            </button>
        </div>
        
        <img v-if="isDesktop" alt="" :id="qrCodeId" 
            src="/img/downloadV3_qr.svg" 
            class="QRCodeBtn img-responsive">
    </div>
</template>
<script>
import { EnumLabels } from '../../../enums/CommonString';
export default {
    props: ['googlePlayId', 'qrCodeId', 'description'],
    data() {
        return {
            EnumLabels,
            isDesktop: false,
            isSmallScreen: window.innerWidth < 1024
        };
    },
    mounted() {
        this.detectDevice();
        window.addEventListener("resize", this.updateScreenSize);
    },
    computed: {
        buttonClass() {
            return this.isSmallScreen ? "d-flex flex-row justify-content-center" : "";
        },
        btnWrapperCls() {
            return this.isSmallScreen ? "d-flex flex-column w-100 px-0" : "d-flex flex-row px-5";
        },
    },
    methods: {
        triggerG4Event(){
            let g4Params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name + "V" + this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name + "V" + this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.$root.$data.transaction.referenceNumber ? this.$root.$data.transaction.referenceNumber.substring(0, 2) : "",
                'transaction_reference': this.$root.$data.transaction.referenceNumber ? this.$root.$data.transaction.referenceNumber : "" ,
            }
            this.$root.triggerG4Event('landing_install_hc_app', g4Params);
        },
        detectDevice() {
            const userAgent = navigator.userAgent;
            this.isDesktop = !/Mobi|Android|iPhone|iPad|iPod/i.test(userAgent) && window.innerWidth > 1024;
        },
        updateScreenSize() {
            this.isSmallScreen = window.innerWidth < 1024;
            this.detectDevice();
        },
        googlePlay() {
            this.triggerG4Event();
            let gPlayURL = "https://play.google.com/store/apps/details?id=ph.homecredit.capp&listing=opg_storelisting&referrer=web_src=opgpage_dl1_gp&utm_source=web-opg&utm_term=opg_page&pli=1";
            window.location.href = `${encodeURI(gPlayURL)}`;
        },
        appleStore() {
            this.triggerG4Event();
            let appStoreURL = "https://apps.apple.com/ph/app/home-credit-online-loan-app/id1577894172?ppid=c806c0bc-61a9-4565-82e9-2bab385b643e&utm_source=web-opg&utm_term=opg_page";
            window.location.href =
                `${encodeURI(appStoreURL)}`;
        },
        huaweiStore() {
            this.triggerG4Event();
            window.location.href =
                "https://appgallery.huawei.com/#/app/C108719055";
        },
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.updateScreenSize);
    },
}
</script>
<style scoped>
.googlePlayBtn {
    height: auto;
    width: 11.625rem;
}

.QRCodeBtn {
    height: auto;
    width: 7rem;
}

.download-banner-v3 {
    .headline {
        font-weight: 600;
        font-size: 1rem;
    }

    label.download-label {
        :first-child {
            font-size: 0.75rem;
        }
    }

    .btn-success {
        background-color: #319E55;
        border-radius: 30px;
        * > *{
            cursor: pointer;
        }
    }
    .dowloadon {
        font-size: 12px;
        line-height: 1;
        text-wrap: nowrap;
    }
    .dowloadlabel {
        font-size: 16px;
        line-height: 1;
        font-weight: 600;
        text-wrap: nowrap;
    }
}
</style>